export const APP_SIGN_IN_SERVICE_INIT = 'APP_SIGN_IN_SERVICE_INIT'
export const APP_SIGN_IN_SERVICE_SUCCESS = 'APP_SIGN_IN_SERVICE_SUCCESS'
export const APP_SIGN_IN_SERVICE_ERROR = 'APP_SIGN_IN_SERVICE_ERROR'
